import React from 'react';

import { useHistory, useLocation } from 'react-router-dom';
import { useCFTabsData } from 'screens/Levelup/LevelUpCF/hooks/dataHooks';
import { checkFeedbackModuleEnabled } from 'utils/helpers/moduleAccess';

import { FeedbackIconDualTone, FeedbackIconHover, FeedbackIconSelected } from 'assets/assetsV1/iconComponents';

import { getMatchesForCurrentRoute, goToContinuousFeedback } from 'constants/helper';

import { SubNavItem } from 'uiToolkitV1/NavBar';

import { HeaderIconContainer } from './common/styles';

const FeedbackSubMenu = () => {
  const history = useHistory();
  const location = useLocation();
  const { isFeedbackMatch, isAnalyticsV0Match } = getMatchesForCurrentRoute(location.pathname, location);
  const { data, isLoading } = useCFTabsData();

  if (!checkFeedbackModuleEnabled()) {
    return null;
  }
  return (
    <HeaderIconContainer onClick={() => goToContinuousFeedback(history)}>
      <SubNavItem
        Icon={FeedbackIconDualTone}
        HoverIcon={FeedbackIconHover}
        ActiveIcon={FeedbackIconSelected}
        isActive={isFeedbackMatch && !isAnalyticsV0Match}
        title="Feedback"
        subTitle="Helps track praises and advices for the employees"
        notificationCount={data?.pendingFeedbackCount}
      />
    </HeaderIconContainer>
  );
};

export { FeedbackSubMenu };
